<template>
  <portal to="absolute-block" :disabled="!isPortal">
    <div class="AppProgressInformation">
      <h3 class="AppProgressInformation__title">{{ response.title }}</h3>
      <p class="AppProgressInformation__description">
        {{ response.description }}
      </p>
      <div class="AppProgressInformation__button-wrapper">
        <app-button-control
          v-if="isChangeRoute"
          class="AppProgressInformation__button"
          type="secondary"
          :route="response.route"
        >
          Перейти
        </app-button-control>
      </div>
      <button
        @click="$emit('close')"
        type="button"
        class="AppProgressInformation__close"
      >
        <app-svg-icon
          isCurrentColor
          name="close"
          class="AppProgressInformation__close-icon"
        ></app-svg-icon>
      </button>
    </div>
  </portal>
</template>

<script>
export default {
  name: 'AppProgressInformation',
  components: {
    AppButtonControl: () => import('@/components/ui/AppButtonControl'),
    AppSvgIcon: () => import('@/components/common/AppSvgIcon'),
  },
  props: {
    isPortal: {
      type: Boolean,
    },
    response: {
      type: Object,
      require: true,
    },
  },
  computed: {
    isChangeRoute() {
      return this.$route.path !== this.response.route;
    },
  },
  methods: {
    /**
     * Смена роута
     */
    changeRoute(route) {
      if (this.$route.path !== route) {
        this.$router.push(route);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.AppProgressInformation {
  position: absolute;
  top: 63px;
  right: 10px;
  z-index: 999;
  width: 390px;
  max-width: 100%;
  padding: 28px;
  padding-bottom: 18px;
  background-color: $white;
  border-radius: 10px;
  box-shadow: 0 4px 40px rgba(0, 0, 0, 0.25);

  @include media-xxs() {
    left: 10px;
    width: auto;
  }

  &__title {
    @include h-reset;

    margin-bottom: 6px;
    font-size: rem(16);
    font-weight: 600;
    line-height: 20px;
    color: $accent;
    text-transform: uppercase;
  }

  &__description {
    margin: 0;
    margin-bottom: 12px;
    font-size: rem(13);
    font-weight: 300;
    line-height: 21px;
  }

  &__button-wrapper {
    display: flex;
    justify-content: flex-end;
  }

  &__close {
    @include button-reset;
    @include size(16px);

    position: absolute;
    top: 12px;
    right: 12px;
    display: flex;
    color: $black;
    opacity: 0.3;
    transition: opacity $A;

    &:hover {
      opacity: 1;
    }
  }

  &__close-icon {
    @include size(12px);

    position: relative;
    display: flex;
    margin: auto;
    fill: currentColor;
    stroke: none !important;
  }
}
</style>
